export const adminListUsers = `query adminListUsers {
  adminListUsers{
      accountId
      userId
      email
      firstName
      lastName
      nickName
      phoneNumber
      language
      active
      isAccountAdmin
      avatarUrl
      preferences {
        decimalSeparator
        thousandsSeparator
        listSeparator
      }
  }
}`;

export const adminGetUser = `query adminGetUser($userId: ID!) {
  adminGetUser(userId: $userId){
      accountId
      userId
      email
      firstName
      lastName
      nickName
      phoneNumber
      language
      active
      isAccountAdmin
      preferences {
        decimalSeparator
        thousandsSeparator
        listSeparator
      }
      parameters
      avatarUrl
  }
}`;

export const userListUsers = `query userListUsers {
  userListUsers{
      accountId
      userId
      email
      firstName
      lastName
      nickName
      phoneNumber
      language
      active
      isAccountAdmin
      avatarUrl
      preferences {
        decimalSeparator
        thousandsSeparator
        listSeparator
      }
  }
}`;

export const userGetUser = `query userGetUser($userId: ID!) {
  userGetUser(userId: $userId){
      accountId
      userId
      email
      firstName
      lastName
      nickName
      phoneNumber
      language
      active
      isAccountAdmin
      avatarUrl
      preferences {
        decimalSeparator
        thousandsSeparator
        listSeparator
      }
  }
}`;

export const userGetUploadUrl = `query userGetUploadUrl($input: UserGetUploadUrlInput) {
  userGetUploadUrl(input: $input){
    url
    bucket
    key
    expires
    contentType
    metadata {
      userId
      accountId
      filename
      createdAt
    }
  }
}`;
